import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../configs/api";
import ImageCarousel from "../../components/AdminSideComponents/common/ImageCarousel";
import { BANNER_IMAGE } from "../../utils/constants";

const AdminProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProject = async () => {
    try {
      setLoading(true);

      const res = await api.get(`/projects/${id}`);
      const data = res.data.data;

      setProject(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAllProjects = async () => {
    try {
      const res = await api.get("/projects?page=1&limit=20");
      const { projects } = res.data.data;

      setProjects(projects);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProject();
    fetchAllProjects();
    window.scrollTo({ top: 0 });
  }, [id]);

  if (loading) return <ProjectDetailsSkeleton />;

  return (
    <>
      {/* HERO BANNER */}
      <div
        className="relative w-full h-[10rem] sm:h-[13rem] md:h-[16rempx] lg:h-[19rem] flex items-center"
        style={{
          backgroundImage: `url(${BANNER_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/20" />

        {/* Content */}
        <div className="relative z-10 w-full px-6 md:px-8 lg:px-10 text-white">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-wider line-clamp-1 mb-2">
            {/* {product?.name} */}
            Project Details
          </h1>

          <div className="text-xs sm:text-sm flex items-center gap-2 text-gray-200">
            <span
              className="cursor-pointer hover:text-white"
              onClick={() => navigate("/")}
            >
              Home
            </span>

            <span>/</span>

            <span
              className="cursor-pointer hover:text-white"
              onClick={() => navigate("/projects")}
            >
              Projects
            </span>

            <span>/</span>

            <span className="text-white font-medium">{project?.name}</span>
          </div>
        </div>
      </div>
      <div className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-10 py-6 lg:pt-10  lg:pb-16">
        <div className="grid lg:grid-cols-3 gap-6">
          {/* LEFT CONTENT */}
          <div className="lg:col-span-3">
            {/* TITLE */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-headingText mb-1.5 sm:mb-3">
              {project?.name}
            </h1>

            <p className="text-descriptionText text-base lg:text-lg mb-6">
              {project?.description}
            </p>

            <div className="mb-6 sm:mb-8 w-full aspect-square sm:aspect-auto  sm:h-[33rem] rounded-lg overflow-hidden ">
              <ImageCarousel
                images={project?.images?.map((img) => ({
                  imageUrl: img,
                  title: project.name,
                }))}
                originalSize={true}
              />{" "}
            </div>

            {/* DESCRIPTION */}
            <div className="mb-8">
              <h2 className="text-2xl font-heading font-semibold uppercase text-headingText mb-4">
                Project Description
              </h2>

              <p className="text-descriptionText leading-relaxed text-justify tracking-wide">
                {project?.description}
              </p>
            </div>

            {/* FEATURES */}
            <div className="mb-8">
              <h2 className="text-2xl font-heading uppercase font-semibold text-headingText mb-4">
                All Features
              </h2>

              <ul className="flex flex-col gap-4">
                {project?.features?.map((feature, i) => (
                  <li
                    key={feature?._id || i}
                    className="flex items-start gap-2 text-descriptionText"
                  >
                    {/* Bullet */}
                    <div className="mt-2 w-1.5 h-1.5 bg-primaryAccent shrink-0 "></div>

                    {/* Content */}
                    <div className="text-sm tracking-wide leading-relaxed">
                      <span className="font-semibold text-md text-left">
                        {feature?.heading}
                      </span>
                      <span className="mx-1">:</span>
                      <span className="text-left tracking-wider">
                        {feature?.description}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* CLOSING TEXT */}
            {/* {product?.closingText && (
              <div className="bg-surfaceAccentLight p-3 sm:p-6 rounded-lg border border-borderLight">
                <p className="text-descriptionText leading-relaxed tracking-wide text-justify">
                  {product.closingText}
                </p>
              </div>
            )} */}
          </div>

          {/* RIGHT SIDEBAR */}
          {/* <div>
            <div className="border border-borderLight rounded-lg p-3 sticky top-24">
              <h3 className="font-heading font-semibold uppercase text-lg text-headingText mb-4">
                Other Projects
              </h3>

              <div className="grid grid-cols-2 gap-3">
                {projects
                  ?.filter((p) => p._id !== id)
                  ?.map((p) => (
                    <div
                      key={p._id}
                      onClick={() => {
                        navigate(`/projects/${p._id}`);
                      }}
                      className="flex items-center gap-2 cursor-pointer group border border-borderLight rounded-md p-2 hover:bg-divider transition"
                    >
                      <img
                        alt={p?.name}
                        src={p.images?.[0]}
                        className="w-12 h-12 object-cover rounded"
                      />

                      <div className="flex flex-col gap-1">
                        <span className="text-xs font-semibold text-headingText group-hover:text-primaryAccent">
                          {p.name}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>{" "}
    </>
  );
};

const ProjectDetailsSkeleton = () => {
  return (
    <div className="w-full animate-pulse">
      {/* HERO BANNER */}
      <div className="relative w-full h-[10rem] sm:h-[13rem] md:h-[16rem] lg:h-[19rem] bg-divider">
        <div className="absolute bottom-6 left-6 md:left-8 lg:left-10 space-y-2">
          <div className="h-6 sm:h-8 w-40 sm:w-56 bg-gray-300 rounded" />
          <div className="h-3 w-32 bg-gray-300 rounded" />
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-10 py-6 lg:pt-10 lg:pb-16">
        <div className="grid lg:grid-cols-3 gap-6">
          {/* LEFT CONTENT */}
          <div className="lg:col-span-2">
            {/* TITLE */}
            <div className="space-y-2 mb-4">
              <div className="h-7 sm:h-9 w-48 sm:w-72 bg-divider rounded" />
              <div className="h-4 w-64 bg-divider rounded" />
            </div>

            {/* IMAGE CAROUSEL */}
            <div className="mb-6 sm:mb-8 w-full aspect-square sm:aspect-auto sm:h-[33rem] rounded-lg bg-divider" />

            {/* PRODUCT OVERVIEW */}
            <div className="mb-8 space-y-3">
              <div className="h-6 w-40 bg-divider rounded" />
              <div className="h-4 w-full bg-divider rounded" />
              <div className="h-4 w-full bg-divider rounded" />
              <div className="h-4 w-3/4 bg-divider rounded" />
            </div>

            {/* FEATURES */}
            <div className="mb-8 space-y-3">
              <div className="h-6 w-36 bg-divider rounded mb-3" />

              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="size-1.5 bg-gray-300 rounded-full" />
                  <div className="h-4 w-full bg-divider rounded" />
                </div>
              ))}
            </div>

            {/* CLOSING TEXT */}
            <div className="bg-divider p-6 rounded-lg border border-borderLight space-y-2">
              <div className="h-4 w-full bg-gray-300 rounded" />
              <div className="h-4 w-3/4 bg-gray-300 rounded" />
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div>
            <div className="border border-borderLight rounded-lg p-5 sticky top-24 space-y-4">
              <div className="h-5 w-36 bg-divider rounded" />

              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-14 h-14 bg-divider rounded" />

                  <div className="flex flex-col gap-2 w-full">
                    <div className="h-3 w-28 bg-divider rounded" />
                    <div className="h-3 w-40 bg-divider rounded" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProjectDetails;
